/*
 * @Author: your name
 * @Date: 2021-12-27 14:14:22
 * @LastEditTime: 2022-01-11 16:24:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \bidding-systemd:\项目\engineer-management-system\src\views\PC\Purchase\add-purchase\add-purchase.js
 */
import {
  deepCopy,
  timeFilter
} from '@/untils/untils'
import * as api from './add-purchase-api'
import html2canvas from 'html2canvas'
import resizeTable from '@/untils/resizeTable'


export default {
  data () {
    return {
      title: '新增采购单',
      /* table */
      tableData: [

      ],
      purchaseInfo: {
        needSheetCategory: '',
        tpId: '',
        name: '',
        projectPrincipal: '', //项目负责人
        technologyPrincipal: '', //技术负责人
        purchaseRemark: '', //采购备注
        purchaseDetailList: [], //采购明细
      },
      originPurchaseInfo: {}, //对比数据是否改变
      projectList: [], //项目下拉框
      purchaseStatusList: [ //项目状态下拉框
        {
          label: "未采购",
          value: '1'
        },
        {
          label: '确认中',
          value: '0'
        },
        // {
        //     label: "询价中",
        //     value: '2'
        // },
        // {
        //     label: "竞价中",
        //     value: '3'
        // },
        // {
        //     label: "合同中",
        //     value: '4'
        // },
        // {
        //     label: "款项申请",
        //     value: '5'
        // },
        // {
        //     label: "待发货",
        //     value: '6'
        // },
        {
          label: "发货中",
          value: '8'
        },
        {
          label: "已完成",
          value: '7'
        },
      ],
      statusMap: {
        status: {
          name: '状态',
          map: {
            "0": '确认中',
            "1": '未采购',
            // "2": '询价中',
            // "3": '竞价中',
            // "4": '合同中',
            // "5": '款项申请',
            // "6": '待发货',
            "7": '已完成',
            "8": '发货中',
          }
        },
        receiveTime: {
          name: '到货时间',
        },
        receiveNum: {
          name: '到货数量'
        },
        remark: {
          name: '备注'
        }
      },
      purchaseCategoryList: [], //采购分类

      /* 是否统一采购状态 */
      changeAllstatus: false,

      /* 新增或是查看 */
      editFlag: false,
      isApproved: false,
      // waitForApproved: false,

      /* 表单验证 */
      validateRules: {
        // 'name': {
        //     rule(val) {
        //         return val ? true : false
        //     },
        //     message: '名称必须填写'
        // },
        // 'model': {
        //     rule(val) {
        //         return val ? true : false
        //     },
        //     message: '型号/规格必须填写'
        // },
        // 'brand': {
        //     rule(val) {
        //         return val ? true : false
        //     },
        //     message: '品牌必须填写'
        // },
        // 'num': {

        //     rule(val) {
        //         let reg = /^\d+(.\d+)?$/
        //         console.log(val);
        //         return reg.test(val) && (val || val == 0)
        //     },
        //     message: '数量必须填写且只能输入数字和小数点'

        // },
        // 'unit': {

        //     rule(val) {
        //         return val ? true : false
        //     },
        //     message: '单位必须填写'

        // },
        // 'mark': {

        //     rule(val) {
        //         return val ? true : false
        //     },
        //     message: '标注必须填写'

        // },
        'receiveTime': {

          rule (val) {
            return val ? true : false
          },
          message: '到货时间必须选择'
        },

        // 'receiveNum': {

        //     rule(val) {
        //         let reg = /^\d+(.\d+)?$/
        //         console.log(val);
        //         return reg.test(val) || !val
        //     },
        //     message: '到货数量只能输入数字和小数点'

        // },
      },

      /* 打印费用详情 */
      isPrinting: false, //是否打印
      printHide: false, //打印需要影藏的元素
      printImgUrl: '',
      printObj: {
        id: "#purchaseImg", //打印区域 Dom ID
        popTitle: '',
        beforeOpenCallback (vue) { },
        closeCallback (vue) {
          vue.isPrinting = false
          vue.printHide = false
        }
      },


    }
  },
  watch: {
    changeAllstatus (val) {
      if (val) {
        let firstStatus = this.purchaseInfo.purchaseDetailList[0]?.status
        this.purchaseInfo.purchaseDetailList = this.purchaseInfo.purchaseDetailList.map(t => {
          t.status = firstStatus
          if (t.status == 7) {
            t.receiveNum = t.num
          } else {
            t.receiveNum = ''

          }
          return t
        })
      }

    }
  },
  async mounted () {
    this.findProjectCategory('purchasetype')
    await this.findProjectDownList()
    let { query: { id } } = this.$route
    console.log(this.$route.query);
    if (id) {
      this.queryPurchaseDetail({
        id
      })
      this.editFlag = true
    }
    this.$nextTick(() => {
      resizeTable()
    })
  },
  methods: {
    /* api*********************************************************************** */
    insertPurchaseSheet (params) { //新增采购单
      api.insertPurchaseSheet(params).then(data => {
        if (data) {
          let msg = data.data.resultMessage
          this.$message.success(msg)
          let d = data.data.resultObject
          this.addActualHour(d)
          this.$router.push('/purchase-list')
        }
      })
    },
    checkboxClick () {
      console.log(11111111);

    },
    addActualHour (params) { //新增日志
      let {
        id: purchaseId,
        purchaseRemark: tahRemark,
        tpId,
        idx
      } = params
      if (this.editFlag) {
        console.log(1)
      } else {
        tahRemark = `新增了【${tahRemark}】需求单`
      }
      const purchaseLogInfo = {
        tahRemark,
        tahStart: timeFilter(+new Date() + (idx || 0)),
        tahEnd: timeFilter(+new Date() + (idx || 0)),
        tpId,
        purchaseId,
      }
      api.addActualHour(purchaseLogInfo).then(data => {
        if (data) {
          let d = data.data.resultObject
        }
      })
    },

    queryPurchaseDetail (params) { //查询采购单明细
      api.queryPurchaseDetail(params).then(data => {
        if (data) {
          let d = data.data.resultObject
          d.purchaseDetailList.map(t => {
            t.status = t.status ? t.status : '1'
            return t
          })
          this.purchaseInfo = d
          this.originPurchaseInfo = deepCopy(d)
        }
      })
    },

    updatePurchase (params) { //修改采购单
      api.updatePurchase(params).then(data => {
        if (data) {
          let msg = data.data.resultMessage
          this.$message.success(msg)
          let d = data.data.resultObject

          /* 查询任务是否改变发送日志 */
          let idx = 0
          let queryArr = ['status', 'receiveTime', 'receiveNum', 'remark']
          console.log(this.originPurchaseInfo.purchaseDetailList);
          this.originPurchaseInfo.purchaseDetailList.map(t => {
            queryArr.map(val => {
              idx += 1000
              this.updateLog(d, t, val, idx)
            })
          })
          this.$router.push({
            path: '/purchase-list',
            query: this.$route.query
          })

        }
      })
    },

    updateLog (d, t, key, idx) {
      console.log(d);
      let res = d.purchaseDetailList.find(item => t.id === item.id)
      if (res) {
        const lastStatus = t[key]
        const newStatus = res[key]
        if (lastStatus !== newStatus) {
          d.idx = idx
          if (key == 'status') {
            d.purchaseRemark = `需求单 : 【${this.originPurchaseInfo.purchaseRemark}】,【${res.name}】的${this.statusMap[key].name} :【${this.statusMap[key]['map'][lastStatus]}】调整为【${this.statusMap[key]['map'][newStatus]}】`
          } else {
            d.purchaseRemark = `需求单 : 【${this.originPurchaseInfo.purchaseRemark}】,【${res.name}】的${this.statusMap[key].name} :【${lastStatus}】调整为【${newStatus}】`
          }
          this.addActualHour(d)
        }

      }
    },

    resetPurchaseSheet (params) { //重新发起采购单

      api.resetPurchaseSheet(params).then(data => {
        if (data) {
          let d = data.data.resultMessage
          this.$message.success(d)
          let {
            id
          } = this.purchaseInfo
          this.$router.push({
            path: '/purchase-list',
            query: {
              id
            }
          })

        }
      })
    },

    findProjectDownList () { //查询项目下拉列表
      api.findProjectDownList({}).then(data => {
        if (data) {
          let d = data.data.resultObject
          this.projectList = d

        }
      })
    },

    findProjectCategory (type) { // 项目分类
      api.findProjectCategory(type).then(data => {
        if (data) {
          let d = data.data.resultObject
          this.purchaseCategoryList = d
        }
      })
    },

    sendPurchaseEmail (params) { // 发送通知邮件
      api.sendPurchaseEmail(params).then(data => {
        if (data) {
          let d = data.data.resultMessage
          this.$message.success(d)
        }
      })
    },
    /* handle*********************************************************************** */
    addNewRow () {
      let data = {
        name: '',
        model: '',
        brand: '',
        num: '',
        unit: '',
        mark: '', //标注
        receiveTime: null,
      }
      this.purchaseInfo.purchaseDetailList.push(data)
    },

    deleteRowData (i) {
      this.purchaseInfo.purchaseDetailList.splice(i, 1)
    },

    copyRowData (row) {
      this.purchaseInfo.purchaseDetailList.push(deepCopy(row))

    },

    submitPurchaseData () {
      let {
        tpId,
        needSheetCategory
      } = this.purchaseInfo
      if (!tpId) return this.$message.warning('请选择项目')
      if (!needSheetCategory) return this.$message.warning('请选择采购单分类')

      if (this.purchaseInfo.purchaseDetailList.length <= 0) return this.$message.warning('采购单明细不能为空')

      // let tableValidate = this.purchaseInfo.purchaseDetailList.some(t => {
      //     return Object.keys(t).some(key => {
      //         let val = t[key]
      //         if (!this.validateRules[key]) return
      //         let { rule = null, message } = this.validateRules[key]
      //         if (!rule(val)) {
      //             this.$message.info(message)
      //             return true
      //         }
      //     })
      // })
      // if (tableValidate) return
      this.editFlag ? this.updatePurchase(this.purchaseInfo) : this.insertPurchaseSheet(this.purchaseInfo)
    },

    backToPurchaseList () {
      this.$router.push({
        path: '/purchase-list',
        query: this.$route.query
      })
    },

    importPurchase (params) {             //导入采集器数据
      const formdata = new FormData()
      const file = params.file
      formdata.append('file', file)
      api.importPurchase(formdata).then(data => {
        if (data) {
          const msg = data.data.resultMessage
          const d = data.data.resultObject
          d.purchaseDetailList.map(t => {
            console.log(t);
            if (!t.receiveTime) {
              t.receiveTime = null
            }
            return t
          })
          this.purchaseInfo = d
          this.$message.success(msg)
        } else {
          this.purchaseInfo = {
            needSheetCategory: '',
            tpId: '',
            name: '',
            projectPrincipal: '', //项目负责人
            technologyPrincipal: '', //技术负责人
            purchaseRemark: '', //采购备注
            purchaseDetailList: [], //采购明细
          }
        }
      })
    },
    seedEmail (row) {
      row.tpId = this.purchaseInfo.tpId
      this.sendPurchaseEmail(row)
    },

    /* 打印 */
    printCostDetail () {
      this.printHide = true
      setTimeout(() => {
        this.htmlToImage()
      }, 100);

    },
    // 保存图片
    htmlToImage () {
      this.$nextTick(() => {
        let dom = document.getElementById('purchaseDetailPrint')
        const scale = window.devicePixelRatio * 2;
        // 传入节点原始宽高
        const width = dom.offsetWidth;
        const height = dom.offsetHeight;
        console.log(width, height);
        let option = {
          scale,
          width,
          height,
          useCORS: true,
          allowTaint: false,
          dpi: window.devicePixelRatio * 300
        }
        html2canvas(dom, option).then(canvas => {
          // 返回图片的二进制数据
          let base64 = canvas.toDataURL('image/png')
          this.printImgUrl = base64
          // document.getElementById('costImg').innerHTML = `<img src="${base64}"/>`
          this.$nextTick(() => {
            this.isPrinting = true
            this.$refs.printBtn.$el.click()
          })
        })
      })

    },

    /* 统一采购单状态  */
    purchaseStatusChange (row, i) {
      if (this.changeAllstatus && i == 0) {
        let firstStatus = row.status
        this.purchaseInfo.purchaseDetailList = this.purchaseInfo.purchaseDetailList.map(t => {
          t.status = firstStatus
          if (t.status == 7) {
            t.receiveNum = t.num
          } else {
            t.receiveNum = ''

          }
          return t
        })
      }
      if (row.status == 7) {
        row.receiveNum = row.num
      } else {
        row.receiveNum = ''

      }

    },

    /* 手机端无法搜索 */
    cancalReadOnly (onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const selects = Array.from(document.querySelectorAll('.mySelect'))
          selects.map(t => {
            let input = t.querySelector('.el-input__inner')
            input.removeAttribute('readonly');
          })
        }
      });
    }
  }
}